import { Directive, Input } from '@angular/core';
import { ClickEventAbstract } from '@df/ui/common/click-event.abstract';

/**
 * Click event directive.
 *
 * ```html
 * <span clickEvent="component.open"></span>
 * ```
 */
@Directive({
    selector: '[clickEvent]',
    standalone: true
})
export class ClickEventDirective extends ClickEventAbstract {
    @Input('clickEvent') name!: string;
}
